module.exports = __webpack_public_path__ + "img/pMaster.760ef7c9.svg";